'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftJs = require('draft-js');

var _selection = require('./utils/selection');

var _SideToolbar = require('./components/SideToolbar');

var _SideToolbar2 = _interopRequireDefault(_SideToolbar);

var _InlineToolbar = require('./components/InlineToolbar');

var _InlineToolbar2 = _interopRequireDefault(_InlineToolbar);

var _ImageComponent = require('./components/ImageComponent');

var _ImageComponent2 = _interopRequireDefault(_ImageComponent);

var _TexComponent = require('./components/TexComponent');

var _TexComponent2 = _interopRequireDefault(_TexComponent);

var _insertTexBlock = require('./modifiers/insertTexBlock');

var _insertTexBlock2 = _interopRequireDefault(_insertTexBlock);

var _SectionBlock = require('./components/SectionBlock');

var _SectionBlock2 = _interopRequireDefault(_SectionBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./styles/Draft.scss');

var RichEditor = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RichEditor, _Component);

  function RichEditor(props) {
    (0, _classCallCheck3.default)(this, RichEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RichEditor.__proto__ || (0, _getPrototypeOf2.default)(RichEditor)).call(this, props));

    var texComponent = function texComponent(componentProps) {
      var component2Props = (0, _extends3.default)({}, componentProps, { onStartEdit: _this.handleStartEdit, onEndEdit: _this.handleEndEdit });
      return _react2.default.createElement(_TexComponent2.default, component2Props);
    };

    var compositeDecorator = new _draftJs.CompositeDecorator([{
      strategy: function strategy(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function (character) {
          var entityKey = character.getEntity();
          return entityKey !== null && contentState.getEntity(entityKey).getType() === 'TEX';
        }, callback);
      },
      component: texComponent
    }]);

    _this.state = {
      editorState: _draftJs.EditorState.createEmpty(compositeDecorator),
      inlineToolbar: { show: false },
      raw: '',
      editing: false
    };

    _this.onChange = function (editorState) {
      if (!editorState.getSelection().isCollapsed()) {
        var selectionRange = (0, _selection.getSelectionRange)();
        var selectionCoords = (0, _selection.getSelectionCoords)(selectionRange, _this.editor);
        _this.setState({
          inlineToolbar: {
            show: true,
            position: {
              top: selectionCoords.offsetTop,
              left: selectionCoords.offsetLeft
            }
          }
        });
      } else {
        _this.setState({ inlineToolbar: { show: false } });
      }

      _this.setState({ editorState: editorState });
      _this.setState({ raw: (0, _draftJs.convertToRaw)(editorState.getCurrentContent()) });
      setTimeout(_this.updateSelection, 0);
    };

    _this.focus = function () {
      if (_this.props.parent) {
        console.log('Set parent read only');
        _this.props.parent.setReadOnly();
      } else {
        console.log('pas de parent');
      }
      console.log('Set focus on editor: ' + _this.refs.editor);
      _this.refs.editor.focus();
    };

    _this.updateSelection = function () {
      return _this._updateSelection();
    };
    _this.handleKeyCommand = function (command) {
      return _this._handleKeyCommand(command);
    };
    _this.handleFileInput = function (event) {
      return _this._handleFileInput(event);
    };
    _this.handleUploadImage = function () {
      return _this._handleUploadImage();
    };
    _this.handleTexValue = function () {
      return _this._handleTexValue();
    };
    _this.toggleBlockType = function (type) {
      return _this._toggleBlockType(type);
    };
    _this.toggleInlineStyle = function (style) {
      return _this._toggleInlineStyle(style);
    };
    _this.insertImage = function () {
      return _this._insertSection();
    };
    _this.handleStartEdit = function () {
      return _this._handleStartEdit();
    };
    _this.handleEndEdit = function () {
      return _this._handleEndEdit();
    };

    _this.blockRenderer = function (block) {
      console.log(block.getType());
      if (block.getType() === 'atomic') {
        var editorState = _this.state.editorState;

        var contentState = editorState.getCurrentContent();
        var entity = contentState.getEntity(block.getEntityAt(0));

        if (entity.type === 'SECTION') {
          return {
            component: _SectionBlock2.default,
            props: {
              parent: {
                setReadOnly: function setReadOnly() {
                  console.log('Call setParentReadOnly');
                  _this.setState({
                    editing: true
                  });
                },
                setEditable: function setEditable() {
                  console.log('Call setParentEditable');
                  _this.setState({
                    editing: false
                  });
                  _this.focus();
                }
              }
            }
          };
        } else if (entity.type === 'IMAGE') {
          return {
            component: _ImageComponent2.default
          };
        }
      }

      return null;
    };
    _this.blockStyler = function (block) {
      if (block.getType() === 'unstyled') {
        return 'paragraph';
      }
      return null;
    };
    return _this;
  }

  (0, _createClass3.default)(RichEditor, [{
    key: '_updateSelection',
    value: function _updateSelection() {
      var selectionRange = (0, _selection.getSelectionRange)();
      var selectedBlock = void 0;
      if (selectionRange) {
        selectedBlock = (0, _selection.getSelectedBlockElement)(selectionRange);
      }
      this.setState({
        selectedBlock: selectedBlock,
        selectionRange: selectionRange
      });
    }
  }, {
    key: '_handleKeyCommand',
    value: function _handleKeyCommand(command) {
      var editorState = this.state.editorState;

      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this.onChange(newState);
        return true;
      }
      return false;
    }
  }, {
    key: '_toggleBlockType',
    value: function _toggleBlockType(blockType) {
      console.log(blockType);
      this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, blockType));
    }
  }, {
    key: '_toggleInlineStyle',
    value: function _toggleInlineStyle(inlineStyle) {
      this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
    }
  }, {
    key: '_insertImage',
    value: function _insertImage(file) {
      var editorState = this.state.editorState;

      var contentState = editorState.getCurrentContent();
      contentState.createEntity('IMAGE', 'IMMUTABLE', { src: URL.createObjectURL(file) });
      this.onChange(_draftJs.AtomicBlockUtils.insertAtomicBlock(this.state.editorState, contentState.getLastCreatedEntityKey(), ' '));
    }
  }, {
    key: '_insertTex',
    value: function _insertTex(texValue) {
      this.onChange((0, _insertTexBlock2.default)(this.state.editorState, texValue));
    }
  }, {
    key: '_insertSection',
    value: function _insertSection() {
      var editorState = this.state.editorState;

      var contentState = editorState.getCurrentContent();
      contentState.createEntity('SECTION', 'IMMUTABLE', { type: 'REMINDER' });
      this.onChange(_draftJs.AtomicBlockUtils.insertAtomicBlock(this.state.editorState, contentState.getLastCreatedEntityKey(), ' '));
    }
  }, {
    key: '_handleFileInput',
    value: function _handleFileInput(event) {
      var fileList = event.target.files;
      var file = fileList[0];
      this.insertImage(file);
    }
  }, {
    key: '_handleUploadImage',
    value: function _handleUploadImage() {
      this.refs.fileInput.click();
    }
  }, {
    key: '_handleTexValue',
    value: function _handleTexValue() {
      var tex = prompt('Saisir une équation', '\\lim _{x \\rightarrow 0} f(x)');
      this._insertTex(tex);
    }
  }, {
    key: '_handleStartEdit',
    value: function _handleStartEdit() {
      this.setState({
        editing: true
      });
    }
  }, {
    key: '_handleEndEdit',
    value: function _handleEndEdit() {
      this.setState({
        editing: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          editorState = _state.editorState,
          selectedBlock = _state.selectedBlock;

      var styles = require('./RichEditor.scss');

      var sideToolbarOffsetTop = 0;

      if (selectedBlock) {
        var editorBounds = this.editor.getBoundingClientRect();
        var blockBounds = selectedBlock.getBoundingClientRect();

        sideToolbarOffsetTop = blockBounds.bottom - editorBounds.top - 28; // height of side toolbar
      }

      return _react2.default.createElement(
        'div',
        { className: styles.richEditor,
          ref: function ref(editor) {
            _this2.editor = editor;
          },
          onClick: function onClick(event) {
            event.stopPropagation();_this2.focus();
          }
        },
        selectedBlock ? _react2.default.createElement(_SideToolbar2.default, {
          editorState: editorState,
          style: { top: sideToolbarOffsetTop },
          onToggle: this.toggleBlockType,
          onUploadImage: this.insertImage,
          onTexInsert: this.handleTexValue
        }) : null,
        this.state.inlineToolbar.show ? _react2.default.createElement(_InlineToolbar2.default, {
          editorState: editorState,
          onToggle: this.toggleInlineStyle,
          position: this.state.inlineToolbar.position
        }) : null,
        _react2.default.createElement(
          'div',
          { style: { display: 'none' } },
          _react2.default.createElement(
            'pre',
            null,
            (0, _stringify2.default)(this.state.raw, null, 2)
          )
        ),
        _react2.default.createElement(_draftJs.Editor, {
          blockRendererFn: this.blockRenderer,
          blockStyleFn: this.blockStyler,
          editorState: editorState,
          handleKeyCommand: this.handleKeyCommand,
          onChange: this.onChange,
          placeholder: this.props.placeholder || '...',
          spellCheck: true,
          readOnly: this.state.editing,
          ref: 'editor'
        }),
        _react2.default.createElement('input', { type: 'file', ref: 'fileInput', style: { display: 'none' },
          onChange: this.handleFileInput })
      );
    }
  }]);
  return RichEditor;
}(_react.Component), _class.propTypes = {
  parent: _react.PropTypes.object,
  placeholder: _react.PropTypes.string
}, _temp);
exports.default = RichEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/RichEditor.js
// module id = 594
// module chunks = 0